module.exports = __webpack_public_path__ + "static/media/no-articles.9048ba88.png";